import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import { ClientDetailsGetExcelStatementDownloadRequest } from 'bff/client';
import { DownloadFileResult, getBlobWithFileName } from 'bff/util/blob-filename-headers';

export const useClientDetailsExcelStatementDownload = (
  request: ClientDetailsGetExcelStatementDownloadRequest,
  options?: UseMutationOptions<DownloadFileResult, Error>
) => {
  const { clientDetailsApi } = useApiClient();

  return useMutation<DownloadFileResult, Error, void>({
    ...options,
    mutationKey: ['clientDetailsExcelStatementDownload'],
    mutationFn: async () => {
      const response = await clientDetailsApi.clientDetailsGetExcelStatementDownloadRaw(request);
      return getBlobWithFileName(response);
    }
  });
};
